<template>
  <v-row
    align="center"
    justify="center"
    class="ma-0"
  >
    <v-col
      cols="12"
      sm="8"
      md="4"
      lg="4"
      xl="3"
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col class="my-4">
          <v-img
            contain
            src="/img/header_logo.png"
            height="40px"
            alt="NetWorkT Team & Telekom Logo"
          />
        </v-col>
      </v-row>
      <v-card outlined>
        <Reset
          :email="email"
          :token="token"
        />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Layout from '@/Layouts/Basic'
import Reset from '@/Components/Auth/Reset'

export default {
   metaInfo: { title: 'Reset Password' },
   components: {
      Reset,
   },
   layout: (h, page) => h(Layout, [page]),

   props: {
      email: {
         type: String,
         required: true,
      },
      token: {
         type: String,
         required: true,
      },
   },

   data () {
      return {
         //
      }
   },

   methods: {
      //
   },
}
</script>
